import React from 'react';
import ToolScreen from '../shared/ToolScreen';
import AirwaysAndCodes from './AirwaysAndCodes';
import EnhancedRecovery from './EnhancedRecovery';
import EpicGuide from './EpicGuide';
import SendingLabs from './SendingLabs';
import NerveBlocks from './NerveBlocks';
import PreopChecklist from './PreopChecklist';
import PostopHandoffAid from './PostopHandoffAid';
import InsulinGuide from './InsulinGuide';
import BivalirudinGuide from './BivalirudinGuide';
import BelmontGuide from './BelmontGuide';
import CaseSetupScreen from './CaseSetupScreen';
import HaikuSetup from '../../itresources/HaikuSetup';
import OktaVerifySetup from '../../itresources/OktaVerifySetup';

/*
 * Tools the THI rotations can open, by action id (the ids used in data/hospitals/thiCvor.js).
 * Each entry either renders a full screen or is an alias to another tool with an argument.
 *   render({ hospital, rotation, arg, open, close }) -> element
 *   alias: [toolId, arg]
 * `notes` is provided by the detail screen for every rotation and is not listed here.
 */
const screen = (subtitle, body) => ({
  render: (ctx) => (
    <ToolScreen hospital={ctx.hospital} subtitle={subtitle} onBack={ctx.close}>
      {body(ctx)}
    </ToolScreen>
  ),
});

const thiTools = {
  'case-setup': {
    render: (ctx) => (
      <CaseSetupScreen hospital={ctx.hospital} onBack={ctx.close} onOpenEnhancedRecovery={() => ctx.open('eras')} />
    ),
  },
  'drug-finder': {
    render: (ctx) => <CaseSetupScreen hospital={ctx.hospital} drugFinder onBack={ctx.close} />,
  },
  epic: {
    render: (ctx) => (
      <ToolScreen hospital={ctx.hospital} subtitle="Epic" onBack={ctx.close}>
        <EpicGuide initialTab={ctx.arg || null} />
      </ToolScreen>
    ),
  },
  ooor: { alias: ['epic', 'ooor'] },
  'epic-orders': { alias: ['epic', 'orders'] },
  'airways-codes': screen('Airways & Codes', (ctx) => <AirwaysAndCodes onOpenEpic={() => ctx.open('epic', 'ooor')} />),
  eras: screen('Enhanced Recovery', () => <EnhancedRecovery />),
  labs: screen('Sending Labs', () => <SendingLabs />),
  'nerve-blocks': screen('Nerve Blocks', () => <NerveBlocks />),
  preop: screen('CV OR Pre-op Checklist', (ctx) => <PreopChecklist onClose={ctx.close} />),
  handoff: screen('Postop Handoff', () => <PostopHandoffAid />),
  insulin: screen('Insulin Infusion', () => <InsulinGuide />),
  bivalirudin: screen('Bivalirudin', () => <BivalirudinGuide />),
  belmont: screen('Belmont Rapid Infuser', () => <BelmontGuide />),
  haiku: screen('How to Set Up Haiku', (ctx) => <HaikuSetup onClose={ctx.close} />),
  okta: screen('How to Set Up Okta Verify', (ctx) => <OktaVerifySetup onClose={ctx.close} />),
};

export default thiTools;
